import React from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { useThemeLayoutConfig } from '../../../../config/ThemeDashboardLayoutConfig';
import appI18n from '../../../../config/i18n';

interface Props {
  editing: boolean;
  onEdit: () => void;
}

/**
 * Header de la Card en modo SOLO LECTURA: unicamente muestra el boton
 * "Editar", que activa la edicion in-place de la seccion (ver
 * SectionEditFooter para los botones Cancelar/Guardar que aparecen en el pie
 * de la Card mientras editing === true). El hover de este boton resalta toda
 * la Card via CSS `:has()` (ver Leads.scss, selector `.lead-section-card:has(...)`).
 * Mientras la seccion esta en edicion, este componente no renderiza nada: las
 * acciones viven en el footer, no en el header.
 */
function SectionActions({ editing, onEdit }: Props) {
  const { t } = useTranslation(undefined, { i18n: appI18n });
  const { theme } = useThemeLayoutConfig();
  const primaryColor = theme.token?.colorPrimary as string | undefined;

  if (editing) return null;

  return (
    <Button
      className="lead-section-edit-btn"
      type="link"
      icon={<EditOutlined />}
      onClick={onEdit}
      style={{ color: primaryColor, padding: 0, height: 'auto' }}
    >
      {t('scenes.leads.components.detail_lead_modal.buttons.edit')}
    </Button>
  );
}

export default SectionActions;
